import React from "react";
import { Expression, Operand } from "@merrie/nmbrs-api";
import { ExpressionComponent } from "../expression/expression.component";
import "./display-expression.component.scss";
import { DisplayExpressionScrollArrowComponent } from "../display-epression-scroll-arrow/display-expression-scroll-arrow.component";

export interface IDisplayExpressionProperties {
  expression: Expression;

  operand?: Operand;
  isEvaluated?: boolean;
}

export const DisplayExpressionComponent: React.FC<IDisplayExpressionProperties> = ({
  expression,
  isEvaluated,
  operand,
}) => {
  const [overflow, setOverflow] = React.useState(false);
  const [arrowLeft, setArrowLeft] = React.useState(false);
  const [arrowRight, setArrowRight] = React.useState(false);

  React.useEffect(() => {
    fitDisplayExpression();

    window.addEventListener("resize", fitDisplayExpression);
    return () => window.removeEventListener("resize", fitDisplayExpression);
  }, [expression, operand]);

  const onScroll = () => {
    setArrows();
  };

  const fitDisplayExpression = () => {
    const scrollContent = document.getElementsByClassName(
      "display-expression-content"
    )[0] as HTMLDivElement;

    if (scrollContent) {
      const { scrollWidth } = scrollContent;
      const { offsetWidth } = scrollContent;

      const overflow = scrollWidth > offsetWidth;
      setOverflow(overflow);

      if (overflow) {
        scroll("right");
        setArrows();
      }
    }
  };

  const setArrows = (): void => {
    const scrollContent = document.getElementsByClassName(
      "display-expression-content"
    )[0] as HTMLDivElement;

    setArrowLeft((scrollContent && scrollContent.scrollLeft > 0) || false);

    setArrowRight(
      (scrollContent &&
        Math.ceil(scrollContent.scrollLeft) !==
          Math.floor(scrollContent.scrollWidth - scrollContent.offsetWidth)) ||
        false
    );
  };

  const scroll = (direction: "left" | "right") => {
    const scrollContent = document.getElementsByClassName(
      "display-expression-content"
    )[0] as HTMLDivElement;

    if (scrollContent) {
      const { offsetWidth } = scrollContent;

      scrollContent.scrollBy({
        left: direction === "left" ? -offsetWidth : offsetWidth,
      });
    }
  };

  return (
    <div className={"display-expression"}>
      {overflow && arrowLeft && (
        <DisplayExpressionScrollArrowComponent
          direction={"left"}
          onClick={() => scroll("left")}
        />
      )}

      <div className={"display-expression-content"} onScroll={() => onScroll()}>
        {(expression.entries.length > 0 ||
          (operand && operand.manipulations.length > 0 && !isEvaluated)) && (
          <ExpressionComponent
            expression={expression}
            operand={
              operand && operand.manipulations.length > 0 && !isEvaluated
                ? operand
                : undefined
            }
            isEvaluated={isEvaluated}
          />
        )}
      </div>

      {overflow && arrowRight && (
        <DisplayExpressionScrollArrowComponent
          direction={"right"}
          onClick={() => scroll("right")}
        />
      )}
    </div>
  );
};
